import angular from 'angular';
import config from './happenings.config';

import {Happenings} from './happenings.component';
import {AddHappening} from './add-happening/add-happening.component';
import {EditHappening} from './edit-happening/edit-happening.component';

import AddStudentController from './../settings/add-student/add-student.controller';
import ViewHappeningController from './view-happening/view-happening.controller';
import AddHappeningStudentController from './add-happening-student/add-happening-student.controller';

import './happenings.scss';

/**
 * @desc  Module initialize.
 *
 * @ngInject
 */
export default angular
  .module('app.modules.happenings', [])
  .component('happeningsComponent', Happenings)
  .component('addHappeningComponent', AddHappening)
  .component('editHappeningComponent', EditHappening)
  .controller('AddStudentController', AddStudentController)
  .controller('ViewHappeningController', ViewHappeningController)
  .controller('AddHappeningStudentController', AddHappeningStudentController)
  .config(config)
  .name;
